import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import NewResponsiveImage from "@components/CustomTypography/NewResponsiveImage/NewResponsiveImage"
import Separator from "@components/CustomTypography/Separator/Separator"
import ButtonSwitcher from "@components/Switchers/ButtonSwitcher/ButtonSwitcher"
import Link from "@components/Theme/Link/Link"
import Typography, {
	Size,
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {getLink} from "@hooks/PagesData/getLink"
import {AdvancedSideAssetMainContent} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./ContactUsHeaderSection.module.scss"

type Props = {
	data: AdvancedSideAssetMainContent
}

const ContactUsHeaderSection = (props: Props) => {
	return (
		<section>
			<ContainerWrapper>
				<Separator size={128}>
					<div className={styles.headerContainer}>
						<Link
							className={styles.headerImageBox}
							link={getLink("locationsM")}
						>
							{props.data.preview && (
								<NewResponsiveImage
									imageClassName={styles.headerImage}
									withoutContainer
									{...props.data.preview}
									alt={
										props.data?.title ??
										props.data.preview?.alt
									}
								/>
							)}
						</Link>
						<div className={styles.headerContentBox}>
							<Typography
								content={props.data.title}
								variant={Variant.SectionTitle}
							/>
							<Separator size={32}>
								<Typography
									content={props.data.content}
									size={Size.S}
									variant={Variant.Description}
								/>
							</Separator>

							<ButtonSwitcher
								buttonsList={props.data}
								withoutTarget
							/>
						</div>
					</div>
				</Separator>
			</ContainerWrapper>
		</section>
	)
}

export default ContactUsHeaderSection
